/**
 * Turns `GET /files/{id}/qr`'s `qrFragmentPath` (`/t#<token>`, API_CONTRACT.md §14.1 —
 * fragment-only so the token never reaches a server log) into the full, absolute URL a
 * phone's camera app can actually open. `QrCode` (`@ministry/ui/internal`) is handed this
 * full URL, never the bare token — a bare token is not something a stock camera app can
 * act on, and API_CONTRACT.md §9.3 is explicit that the QR "encodes `https://<host>/t#
 * <token>`", not the token alone.
 *
 * `<host>` is the CITIZEN portal's origin (`web/public`), which is a DIFFERENT app from
 * this one (ADR-0004 §97/98: `internal-api` and `public-api` are separate processes,
 * separated by hostname/path at the reverse proxy — ADR-0004's own words). This file
 * cannot assume same-origin the way `api-client.ts` assumes the API is same-origin as
 * this SPA, so it reads its own env var rather than reusing `API_BASE_URL`.
 *
 * The dev fallback (`http://127.0.0.1:5174`) matches `web/public/vite.config.ts`'s own
 * documented dev port, the same convention `api-client.ts`'s `API_BASE_URL` fallback
 * already uses for the API's port — so `npm run dev` produces a scannable QR against a
 * locally-running citizen portal with no `.env` file at all. Production sets
 * `VITE_PUBLIC_APP_ORIGIN` to the real citizen-facing hostname; suggested `.env.example`
 * line in this agent's handback (this agent does not create or edit `.env*` files itself,
 * CLAUDE.md §4).
 */
const PUBLIC_APP_ORIGIN = ((import.meta.env.VITE_PUBLIC_APP_ORIGIN as string | undefined) ?? 'http://127.0.0.1:5174').replace(
  /\/$/,
  '',
);

export function trackingQrUrl(qrFragmentPath: string): string {
  return `${PUBLIC_APP_ORIGIN}${qrFragmentPath}`;
}
